import { Grid2, TextField, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

type UserAndRoomDetailsProps = {
  manualUsername: string;
  roomName: string | null;
  usernameError: boolean;
  username: string | null;
  handleManualUsernameChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

const useStyles = makeStyles((theme: Theme) => ({
  usernameHeading: {
    textTransform: 'capitalize',
  },
}));

const UserAndRoomDetails: React.FC<UserAndRoomDetailsProps> = ({
  manualUsername,
  roomName,
  usernameError,
  username,
  handleManualUsernameChange,
}) => {
  const classes = useStyles();

  return (
    <Grid2>
      <Grid2>
        {username ? (
          <Typography variant="h6" className={classes.usernameHeading}>
            User: {username}
          </Typography>
        ) : (
          <>
            <TextField
              id="username-text"
              label="Username*"
              variant="outlined"
              autoFocus={true}
              value={manualUsername}
              onChange={handleManualUsernameChange}
              error={usernameError}
            />
            {usernameError && (
              <Typography variant="body1" sx={{ color: 'error.main' }}>
                Username is required
              </Typography>
            )}
          </>
        )}
      </Grid2>
      <Grid2>
        <Typography variant="h6">Room: {roomName}</Typography>
      </Grid2>
    </Grid2>
  );
};

export default UserAndRoomDetails;
